import { useState } from "react";

export const trimRowForView = (row: Record<string, any>): Record<string, any> => {
    const result: Record<string, any> = {};
    const ALLOWED_IDS: string[] = ["exec_id", "leg_id"];
    const EXCLUDE_KEYS: string[] = [
        "is_deleted",
        "deleted_at",
        "created_at",
        "retrieved_at",
        "updated_at",
    ];

    Object.entries(row).forEach(([key, value]) => {
        if (ALLOWED_IDS.includes(key)) {
            result[key] = value;
            return;
        }
        if (EXCLUDE_KEYS.includes(key)) return;
        if (
            key === "id" ||
            key.endsWith("_id") ||
            key.includes("connection") ||
            key.includes("object") ||
            (typeof value === "string" &&
                /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value))
        ) {
            return;
        }
        if (row[`${key}_formatted`]) return;
        if (
            (key === "date" && row.formatted_date) ||
            (key === "pricing_from" && row.pricing_from_formatted) ||
            (key === "pricing_to" && row.pricing_to_formatted)
        ) {
            return;
        }
        result[key] = value;
    });

    Object.entries(row).forEach(([key, value]) => {
        if (key.endsWith("_formatted")) {
            result[key.replace("_formatted", "")] = value;
        }
    });

    return result;
};

export const useViewRow = () => {
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState<Record<string, any> | null>(null);

    const handleViewRow = (row: any) => {
        const cleaned = trimRowForView(row.original);
        setSelectedRowData(cleaned);
        setViewModalOpen(true);
    };

    const handleCloseViewModal = () => {
        setViewModalOpen(false);
    };

    return {
        viewModalOpen,
        selectedRowData,
        handleViewRow,
        handleCloseViewModal,
    };
};